import { Component, DestroyRef, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { CommonMenuService } from '@shared/services/common-util.service';
import { ConfirmationService, MenuItem } from 'primeng/api';
import { DriverService } from '../driver/services/driver.service';
import { ToastService } from '@shared/services/toast.service';
import { ActivatedRoute } from '@angular/router';
import { DriverNotesHistory } from '@core/models/api-response.model';
import { autoUnsubWith } from '@shared/services/utility.abstract';

@Component({
  selector: 'app-notes',
  templateUrl: './notes.component.html',
  styleUrls: ['./notes.component.scss']
})
export class NotesComponent implements OnInit{
  readonly destroyRef = inject(DestroyRef);
  @Input() driverNotesHistory:DriverNotesHistory [] = [];
  @Input() hasNotesPermission;
  @Output() addNotes = new EventEmitter<any>();
  items: MenuItem[] | undefined;
  activeItem: any;
  driverId: string;

  constructor(private readonly commonMenuService: CommonMenuService,
    private readonly driverService: DriverService,
    private readonly toasterService: ToastService,
    private readonly route: ActivatedRoute,
    private readonly confirmationService : ConfirmationService) { }

  ngOnInit() {
    this.route.queryParams?.subscribe((params) => {
      this.driverId = params['id'] || params['Id'];
    });
  }

showData(_product: any,event:any) {
    const actionMap = {
      delete: () => {
        this.deleteNote(_product,event);
      }
    };
    const config = [
      {
        label: '',
        icon: '',
      },
      {
        label: 'Delete',
        icon: 'common-icon custom-delete',
        command: actionMap.delete
      },
    ];

    this.items = this.commonMenuService.commonShowData(config);
  }

  addNote() {
    this.addNotes.emit({ notesData: true });
  }

  eventTitle(event): { title: string, iconPath: string } {
    switch (event.eventName) {  
      case 1:
        return { title: 'Profile Created By', iconPath: '../../../../../assets/images/note-icon4.svg' };
      case 2:
        return { title: 'Password Reset', iconPath: '../../../../../assets/images/note-icon2.svg' };
      case 3:
        return { title: 'Password Change', iconPath: '../../../../../assets/images/note-icon3.svg' };
      default:
        return { title: 'Notes', iconPath: '../../../../../assets/images/note-icon1.svg' };
    }
  }

  deleteNote(noteId: string, event): void {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: 'Are you sure you want to delete this note?',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
      this.driverService.deleteNoteById(noteId)
      .pipe(autoUnsubWith(this.destroyRef))
      .subscribe({
        next: (response) => {
          
          this.toasterService.showToastMessage('success', 'Success', response.message);
          this.getDriverNotesHistory(this.driverId);
        },
        error: (_error) => {
          this.getDriverNotesHistory(this.driverId);
        }
      });
    }
    });
  }
  getDriverNotesHistory(driverId: string): void {
    
    this.driverService.getDriverNotesHistoryByDriverIdForSuperAdmin(driverId)
      .pipe(autoUnsubWith(this.destroyRef))
      .subscribe({
        next: (response) => {
          this.driverNotesHistory = response;
          
        },
        error: (_error) => {
          this.driverNotesHistory = [];
        }
      });
  }
}
